
// import { CountryISO } from '@/models/enums'
import { CountryNames, CountriesByISO, CountriesByISOAlpha3 } from '@/constants/country_iso_dict'
import { Address } from '@/models/generics'
import { isJSON } from '.'

// TODO move to error util
  export function extractSOAPError (string) {
    if (typeof string !== 'string') return string
    const messageMatch = string.match(/<message>(.*)<\/message>/g)
    if (messageMatch) return messageMatch[0]
    const match = string.match(/<faultstring>(.*)<\/faultstring>/g)
    return match ? match[0].replace('<faultstring>', '').replace('</faultstring>', '') : string
  }

  // {"failed": "{\"sys\":{\"service\":{\"id\":\"directr\",\"type\":\"directr\"},\"type\":\"warn\",\"code\":0,\"flag\":\"ship-1004017597\",\"id\":\"01FXMFVNEZE84FHJMJBBKGAEJV\",\"source\":\"ship\"},
  // \"message\":\"1 item not processed\",\"payload\":{\"entry\":[{\"status\":\"rejected\",\"reason\":\"<?xml version=\\\"1.0\\\" encoding=\\\"utf-8\\\"?><soap:Envelope xmlns:soap=\\\"http://schemas.xmlsoap.org/soap/envelope/\\\" xmlns:xsi=\\\"http://www.w3.org/2001/XMLSchema-instance\\\"
  // xmlns:xsd=\\\"http://www.w3.org/2001/XMLSchema\\\"><soap:Body><soap:Fault><faultcode>soap:Server</faultcode><faultstring>The 'houseNo' element is invalid - The value 'undefined' is invalid according to its datatype 'String' - The actual length is greater than the
  // MaxLength value.</faultstring><detail /></soap:Fault></soap:Body></soap:Envelope>\"}],\"failed\":[\"<?xml version=\\\"1.0\\\" encoding=\\\"utf-8\\\"?><soap:Envelope xmlns:soap=\\\"http://schemas.xmlsoap.org/soap/envelope/\\\" xmlns:xsi=\\\"http://ww
  // w.w3.org/2001/XMLSchema-instance\\\" xmlns:xsd=\\\"http://www.w3.org/2001/XMLSchema\\\"><soap:Body><soap:Fault><faultcode>soap:Server</faultcode><faultstring>The 'houseNo' element is invalid - The value 'undefined' is invalid according to its
  // datatype 'String' - The actual length is greater than the MaxLength value.</faultstring><detail /></soap:Fault></soap:Body></soap:Envelope>\"],\"id\":\"1004017597\",\"type\":\"order\"}}"}
  export function errorToReadableString (error): string {
    try {
      if (!error) return error
      let e = error
      // test for stringified JSON...
      if (typeof e === 'string' && isJSON(e)) e = JSON.parse(e)
      if (typeof e !== 'object') return error.toString ? error.toString() : error

      const messages:Array<string> = []
      // traverse the error object for every payload encountered, and collect the messages
      while (e && (e.error || e.payload || e.message || e.failed || e._payload)) {
        if (e.error && typeof e.error === 'string') messages.push(e.error)
        if (!e.message && e._sys && e._sys.code && e._sys.flag) messages.push(`${e._sys.code === 404 ? 'Not Found (404)' : e._sys.code} ${e._sys.flag.replace(e._sys.source, '')}`)
        if (!e.message && e._payload) e = e._payload
        if (!e.message && !e.payload && e.error) e = e.error
        if (Array.isArray(e.failed)) e = e.failed.flat(10)
        if (e.message) messages.push(e.message && e.message.toString ? extractSOAPError(e.message.toString()) : '.')
        if (e.reason) messages.push(e.reason && e.reason.toString ? extractSOAPError(e.reason.toString()) : '.')
        if (e.failed && typeof e.failed !== 'object') messages.push(e.failed && e.failed.toString ? extractSOAPError(e.failed.toString()) : '.')
        if (Array.isArray(e)) e.forEach(f => typeof f === 'string'
          ? messages.push(extractSOAPError(f))
          : (f.message || f.description || f.Message || f.Description)
            ? messages.push(f.message || f.description || f.Message || f.Description)
            : typeof (f.error || f.Error) === 'string' ? messages.push(f.error || f.Error) : undefined
        )

        e = e.payload || e._payload
      }
      return messages.filter(f => !!f).join(', ')
    } catch (e) {
      console.warn('There was an issue while attempting to parse error messages', e)
      return ''
    }
  }

export function validateAddress (address): Record<string, Record<string, any>> {
  return Object.keys(address).reduce((s: Record<string, Record<string, any>>, key: string) => {
    const val = address[key]
    // simple switch on address key values, checking if the value is valid
    switch (key) {
      // case 'firstname':
      //   return s
      // case 'lastname':
      //   return s
      case 'fullname':
        return s
      case 'phone':
        return s
      case 'zipcode':
        return !(val === undefined || val === null) ? s : {...s, [key]: { type: !val ? 0 : 1, error: !val ? 'Missing Zipcode name' : 'Invalid Zipcode name' }}
      case 'city':
        return !(val === undefined || val === null) ? s : {...s, [key]: { type: !val ? 0 : 1, error: !val ? 'Missing City name' : 'Invalid City name' }}
      case 'country':
        return s
      case 'country_iso':
        return CountriesByISO[val?.toUpperCase()] || CountriesByISOAlpha3[val?.toUpperCase()] ? s : {...s, [key]: { type: !val ? 0 : 1, error: !val ? 'Missing Country ISO' : 'Invalid Country ISO' }}
      case 'street_number':
        return !(val === undefined || val === null || isNaN(parseInt(val))) ? s : {...s, [key]: { type: !val ? 0 : 1, error: !val ? 'Missing Street number' : 'Invalid Street number' }}
      case 'addition':
        return s
      case 'company':
        return s
      case 'street':
        return !(val === undefined || val === null) ? s : {...s, [key]: { type: !val ? 0 : 1, error: !val ? 'Missing Street name' : 'Invalid Street name' }}
      default:
        return s
    }
  }, {})
}

export function addressIssuesToString (address: Address = {}): string {
  const issues = validateAddress(address)
  return Object.keys(issues).reduce((s: string, key: string) => {
    return `${s}. ${issues[key].error}`
  }, '')
}
